import http from '@/services/rest/rest.service';
import { ILoginLog } from '@/entities/logs/login-log.interface';
import { IPaging } from '@/entities/paging.interface';
import { IGetLoginLogs } from '@/entities';

export default {
    list(body: IGetLoginLogs): Promise<IPaging<ILoginLog>> {
        return http.post('login-logs/search', body);
    }
};
